import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid/index";

export interface Check {
    text: string,
    status: string,
}

function CheckItem({ text, status }: Check) {
    return (
        <div className="flex items-center w-full mb-0.5">
            {status === 'ok' ? (
                <CheckCircleIcon className="h-5 w-5 text-green-500" />
            ) : (
                <XCircleIcon className="h-5 w-5 text-red-500" />
            )}
            <span className="ml-1 text-sm text-gray-700">{text}</span>
        </div>
    );
}

export function MatchChecksDashboard({ checks }: { checks: Check[] }) {
    return <>{checks.map((check, index) => (
        <CheckItem key={index} text={check.text} status={check.status} />
    ))}</>;
}
